<button type="button" class="image-selector"
        [ngbTooltip]="imageFilename || 'Select a image'"
        (click)="selector_click()"
        [style.background-image]="imageDataUrl"
        [class]="customClass">

    <i class="fa-regular fa-solid fa-fw" [class]="{'fa-times': imageFile!=null, 'fa-image': imageFile==null}"></i>

</button>
<input type="file" class="form-control" name="image" (change)="fileChanged($event)" #imageSelector accept="image/png, image/jpeg" hidden />
